import {
  Activity, BarChart3, LayoutDashboard, CalendarDays, StickyNote, TrendingUp, Megaphone, BadgeDollarSign,
  Lightbulb, Package, Coffee, Globe, Briefcase, Building2, Handshake, Users, ShieldCheck, Scale, FileText,
  Receipt, MapPin, FolderKanban, Bug, Settings, Shield, Building, Mail, Network, UserCircle, Link as LinkIcon,
  Star, Bookmark, Folder, Home, Wrench, Plane, type LucideIcon,
} from "lucide-react";

export const MENU_ICONS: Record<string, LucideIcon> = {
  Activity, BarChart3, LayoutDashboard, CalendarDays, StickyNote, TrendingUp, Megaphone, BadgeDollarSign,
  Lightbulb, Package, Coffee, Globe, Briefcase, Building2, Handshake, Users, ShieldCheck, Scale, FileText,
  Receipt, MapPin, FolderKanban, Bug, Settings, Shield, Building, Mail, Network, UserCircle, Link: LinkIcon,
  Star, Bookmark, Folder, Home, Wrench, Plane,
};

export type MenuItem = {
  id: string;
  label: string;
  url?: string;
  icon: string;
  hidden?: boolean;
  external?: boolean;
  children?: MenuItem[];
};
export type MenuSection = { id: string; label: string; hidden?: boolean; adminOnly?: boolean; items: MenuItem[] };
export type MenuConfig = { sections: MenuSection[] };

const i = (id: string, label: string, url: string, icon: string): MenuItem => ({ id, label, url, icon });

export const DEFAULT_MENU: MenuConfig = {
  sections: [
    { id: "main", label: "", items: [
      i("activity", "Activity", "/", "Activity"),
      i("analytics", "Analytics", "/analytics", "BarChart3"),
      i("executive", "Executive Dashboard", "/executive", "LayoutDashboard"),
    ] },
    { id: "portals", label: "Portals", items: [
      i("sales", "Sales", "/department/sales", "TrendingUp"),
      i("marketing", "Marketing", "/department/marketing", "Megaphone"),
      i("finance", "Finance", "/department/finance", "BadgeDollarSign"),
      i("research", "R&D", "/department/research", "Lightbulb"),
      { id: "operations", label: "Operations", icon: "Activity", children: [
        i("ops_cb", "Coffeebeans", "/operations/coffeebeans", "Coffee"),
        i("ops_ct", "Creative Travel", "/operations/creative-travel", "Globe"),
        i("ops_ss", "SnapStack", "/operations/snapstack", "Package"),
        i("ops_ws", "Weekend Specials", "/operations/weekend-specials", "CalendarDays"),
      ] },
      { id: "company_admin", label: "Company Admin", icon: "Briefcase", children: [
        i("ca_overview", "Overview", "/portal/company-admin", "FolderKanban"),
        i("ca_reg", "Company Registration", "/portal/company-admin/company-registration", "Building2"),
        i("ca_ft", "FAIR TRADE", "/portal/company-admin/fair-trade", "Handshake"),
        i("ca_hr", "HR", "/portal/company-admin/hr", "Users"),
        i("ca_ins", "Insurance", "/portal/company-admin/insurance", "ShieldCheck"),
        i("ca_legal", "Legal", "/portal/company-admin/legal", "Scale"),
        i("ca_rates", "Our Rates", "/portal/company-admin/our-rates", "FileText"),
        i("ca_srates", "Supplier Rates", "/portal/company-admin/supplier-rates", "Receipt"),
        i("ca_sars", "SARS", "/portal/company-admin/sars", "Receipt"),
      ] },
    ] },
    { id: "database", label: "Database", items: [
      i("clients", "Clients", "/clients", "Users"),
      i("destinations", "Destinations", "/destinations", "MapPin"),
      i("suppliers", "Suppliers", "/suppliers", "Building2"),
      i("products", "Products", "/products", "Package"),
    ] },
    { id: "apps", label: "Apps", items: [
      i("calendar", "Calendar", "/calendar", "CalendarDays"),
      i("notepad", "Notepad", "/notepad", "StickyNote"),
      i("projects", "Projects", "/projects", "FolderKanban"),
    ] },
    { id: "admin", label: "Admin", adminOnly: true, items: [
      i("brand", "Brand Settings", "/brand-settings", "Building"),
      i("channels", "Channel Manager", "/admin/channels", "Network"),
      i("email_tpl", "Email Templates", "/admin/email-templates", "Mail"),
      i("menu_mgr", "Menu Manager", "/admin/menu-manager", "Settings"),
      i("webhook", "Payment Webhook", "/payment-webhook", "Activity"),
      i("profile", "Profile", "/profile", "UserCircle"),
      i("plan", "Project Plan", "/project-setup-summary", "FileText"),
      i("setup", "Project Setup", "/project-setup", "Settings"),
      i("users", "Users", "/users", "Shield"),
      i("issues", "View Issues", "/issues", "Bug"),
    ] },
  ],
};

export const newId = () => Math.random().toString(36).slice(2, 10);
